import { authHeader, getApiUrl, handleError, handleResponse } from '@/_helpers/http';
import {IUser, IUserEdit} from "@/_objects/IUser";

export async function login(email: string, password: string): Promise<string> {
    const requestOptions: RequestInit = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
    };

    return fetch(`${await getApiUrl()}/users/self/login`, requestOptions)
        .then(handleResponse)
        .then((data) => {
            return data ? data.token : null;
        })
        .catch(handleError);
}

export async function forgot(email: string): Promise<string> {
    const requestOptions: RequestInit = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
    };

    return fetch(`${await getApiUrl()}/users/self/forgot`, requestOptions)
        .then(handleResponse)
        .then((data) => {
            return data ? data.status : null;
        })
        .catch(handleError);
}

export async function verifyResetToken(token: string): Promise<string> {

    const params: RequestInit = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${await getApiUrl()}/users/self/verify-reset-token?token=${token}`, params)
        .then(handleResponse)
        .then((data) => {
            return data ? data.status : null;
        })
        .catch(handleError);
}

export async function resetPW(token: string, password: string, confirmPassword: string): Promise<string> {
    const requestOptions: RequestInit = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({token, password, confirmPassword }),
    };

    return fetch(`${await getApiUrl()}/users/self/reset-pw`, requestOptions)
        .then(handleResponse)
        .then((data) => {
            return data ? data.status : null;
        })
        .catch(handleError);
}

export async function getSelf(): Promise<IUser> {

    const params: RequestInit = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${await getApiUrl()}/users/self`, params)
        .then(handleResponse)
        .catch(handleError);
}

export async function refreshToken(): Promise<string> {
    const params: RequestInit = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${await getApiUrl()}/users/self/refresh`, params)
        .then(handleResponse)
        .then((data) => {
            return data.token;
        })
        .catch(handleError);
}

export async function search(): Promise<IUser[]> {

    const params: RequestInit = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${await getApiUrl()}/users/search`, params)
        .then(handleResponse)
        .catch(handleError);
}

export async function updateActive(userId: string, isActive: boolean): Promise<IUser> {
    const requestOptions: RequestInit = {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify({ isActive }),
    };

    return fetch(`${await getApiUrl()}/users/${userId}/active`, requestOptions)
        .then(handleResponse)
        .catch(handleError);
}

export async function create(user: IUserEdit): Promise<IUser> {
    const requestOptions: RequestInit = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(user),
    };

    return fetch(`${await getApiUrl()}/users/`, requestOptions)
        .then(handleResponse)
        .catch(handleError);
}

export async function update(user: IUserEdit): Promise<IUser> {
    const requestOptions: RequestInit = {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(user),
    };

    return fetch(`${await getApiUrl()}/users/${user.id}`, requestOptions)
        .then(handleResponse)
        .catch(handleError);
}
